import Vue from 'vue'
import AppRoot from './AppRoot.vue'
import router from './router'

Vue.config.productionTip = false

new Vue({
  router,
  render: h => h(AppRoot),
}).$mount('#app')
